module.exports = __webpack_public_path__ + "static/media/saif.d20c07b4.webp";